import { React, classNames } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Text } from '@digsup/components-text';

const cx = classNames;

export const Title = ({ marginBottom, children, className, ...props }) => {
  const classes = cx(
    {
      'u-margin-bottom-xlarge': marginBottom === 'medium',
      'u-margin-bottom-xxlarge': marginBottom === 'large',
    },
    className,
  );
  return (
    <div className={classes} {...props}>
      <Text
        size="xs"
        fontFamily="serif"
        fontWeight="semibold"
        align="center"
        marginBottom="small">
        {children}
      </Text>
      <div className="u-background-digsup-blue" style={{ height: 1 }} />
    </div>
  );
};

Title.propTypes = {
  marginBottom: PropTypes.oneOf(['none', 'medium', 'large']),
  children: PropTypes.any,
  className: PropTypes.string,
};

Title.defaultProps = {
  marginBottom: 'large',
  className: '',
};
